"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkOrderSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class WorkOrderSearchResponse extends common_1.PaginatedResponse {
}
exports.WorkOrderSearchResponse = WorkOrderSearchResponse;
//# sourceMappingURL=work-order-search.response.js.map